<template>
  <div class="c-filter">
    <div class="c-form">
      <ElForm label-width="60" inline class="elementui-common-form-styles" v-highlight>
        <ElFormItem label-width="0" class="bg-transparent g-pull-right">
          <ElButton type="primary" @click="sendEvent">查询</ElButton>
        </ElFormItem>

        <ElFormItem>
          <ElInput v-model="keyword" clearable placeholder="请输入关键词" style="width: 220px" @keyup.enter.native="sendEvent">
            <ElSelect v-model="searchType" slot="prepend" style="width: 64px">
              <ElOption :value="1" label="素材"></ElOption>
              <ElOption :value="2" label="计划"></ElOption>
            </ElSelect>
          </ElInput>
        </ElFormItem>

        <ElFormItem label="素材游戏组">
          <el-select v-model="groupId" filterable clearable placeholder="全部">
            <el-option v-for="item in GAME_GROUPS" :key="item.id" :label="item.name" :value="item.id"> </el-option>
          </el-select>
        </ElFormItem>

        <ElFormItem label="数据游戏组">
          <el-select v-model="dataGroupId" filterable clearable placeholder="全部">
            <el-option v-for="item in GAME_GROUPS" :key="item.id" :label="item.name" :value="item.id"> </el-option>
          </el-select>
        </ElFormItem>

        <ElFormItem label="上传时间">
          <DateRangePicker v-model="uploadtime" style="width: 220px"></DateRangePicker>
        </ElFormItem>

        <ElFormItem label="统计时间">
          <DateRangePicker
            v-model="datetime"
            :pickerOptions="{ disabledDate }"
            :clearable="false"
            style="width: 220px"
            @change="handleDatetime"
          ></DateRangePicker>
        </ElFormItem>
        <ElFormItem label="设计者">
          <el-select v-model="opId" filterable clearable placeholder="全部" style="width: 110px">
            <el-option v-for="item in SYS_USERS" :key="item.id" :label="item.name" :value="item.id"> </el-option>
          </el-select>
        </ElFormItem>
        <ElFormItem label="策划者">
          <el-select v-model="plannerId" filterable clearable placeholder="全部" style="width: 110px">
            <el-option v-for="item in SYS_USERS" :key="item.id" :label="item.name" :value="item.id"> </el-option>
          </el-select>
        </ElFormItem>
        <ElFormItem label="素材游戏">
          <el-select v-model="gameId" filterable clearable placeholder="全部" style="width: 170px">
            <el-option v-for="item in GAMES" :key="item.id" :label="item.name" :value="item.id"> </el-option>
          </el-select>
        </ElFormItem>
        <ElFormItem label="数据游戏">
          <el-select v-model="dataGameId" filterable clearable placeholder="全部" style="width: 170px">
            <el-option v-for="item in GAMES" :key="item.id" :label="item.name" :value="item.id"> </el-option>
          </el-select>
        </ElFormItem>

        <ElFormItem label="媒体" label-width="40px">
          <el-select v-model="mediaId" filterable clearable placeholder="全部" style="width: 170px">
            <el-option v-for="item in MEDIAS" :key="item.id" :label="item.name" :value="item.id"> </el-option>
          </el-select>
        </ElFormItem>

        <ElFormItem label="计划账号" label-width="70px">
          <ThrottleSelector
            style="width: 180px"
            v-model="mediaAccount"
            multiple
            collapse-tags
            :list="MEDIA_ACCOUNTS"
            placeholder="全部"
            filterable
            clearable
          />
        </ElFormItem>

        <ElFormItem label="素材类型">
          <ElSelect v-model="imageId" style="width: 100px" clearable>
            <ElOption v-for="item in imageTypes" :key="item.id" :label="item.name" :value="item.id"></ElOption>
          </ElSelect>
        </ElFormItem>

        <ElFormItem label="素材样式">
          <el-cascader
            v-model="imageStyles"
            clearable
            filterable
            collapse-tags
            style="width: 200px"
            :props="{ label: 'content', value: 'labelId', multiple: true }"
            :options="IMAGE_STYLE_TAG_TREE"
          >
          </el-cascader>
        </ElFormItem>

        <ElFormItem label="内容标签组">
          <el-select v-model="tagGroups" filterable clearable multiple collapse-tags style="width: 160px" placeholder="全部">
            <el-option v-for="item in SYS_TAG_GROUPS" :key="item.id" :label="item.name" :value="item.id"> </el-option>
          </el-select>
        </ElFormItem>
        <ElFormItem label="内容标签">
          <el-select v-model="labelId" multiple collapse-tags filterable clearable placeholder="全部" :multiple-limit="10">
            <el-option
              v-for="label in labelList.contentLabels"
              :key="label.id"
              :value="label.id"
              :label="label.name"
              style="width: 230px"
            ></el-option>
          </el-select>
        </ElFormItem>
        <ElFormItem label="来源" label-width="40">
          <ElSelect v-model="source" style="width: 100px" clearable placeholder="全部">
            <ElOption v-for="item in SOURCE_TYPES" :key="item.value" :value="item.value" :label="item.label"></ElOption>
          </ElSelect>
        </ElFormItem>
        <ElFormItem label="计划投放人">
          <el-select v-model="launchOpIdList" filterable collapse-tags multiple clearable placeholder="全部" style="width: 180px">
            <el-option v-for="item in SYS_USERS" :key="item.id" :label="item.name" :value="item.id"> </el-option>
          </el-select>
        </ElFormItem>

        <ElFormItem label="数据平台">
          <el-select v-model="launchOpIdList" collapse-tags multiple clearable placeholder="全部" style="width: 150px">
            <el-option
              v-for="item in [
                { id: 1, name: '安卓' },
                { id: 2, name: 'IOS' },
                { id: 3, name: '小程序' },
                { id: 5, name: '鸿蒙' }
              ]"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </ElFormItem>

        <ElFormItem label="AI标签">
          <el-cascader
            ref="aiLabelCascaderRef"
            clearable
            filterable
            v-model="aiLabelIds"
            collapse-tags
            placeholder="请选择AI标签"
            style="width: 200px"
            :props="{ label: 'content', value: 'labelId', multiple: true }"
            :options="AI_TAG_TREE"
          >
          </el-cascader>
        </ElFormItem>

        <ElFormItem label="消耗起始时间" label-width="85">
          <DateRangePicker v-model="lauchTime" style="width: 220px"></DateRangePicker>
        </ElFormItem>

        <ElFormItem label="3D视频源" label-width="65">
          <el-select v-model="videoLabelId" filterable collapse-tags multiple clearable placeholder="全部" style="width: 180px">
            <el-option v-for="item in labelList.threeDLabels" :key="item.id" :label="item.name" :value="item.id"> </el-option>
          </el-select>
        </ElFormItem>
      </ElForm>
    </div>
  </div>
</template>
<script>
import moment from 'moment'
import { trim } from '@/common/js/utils'
import DateRangePicker from '@/components/date-range-picker'
import ThrottleSelector from '@/components/throttle-select/index.vue'
import { transferTaskQueryConditions } from '@/views/download-center/data/utils.js'

import {
  initPageData,
  PROJECT_GROUP,
  MEDIA_ACCOUNTS,
  GAME_GROUPS,
  GAMES,
  MEDIAS,
  SYS_USERS,
  SYS_TAGS,
  SYS_TAG_GROUPS,
  IMAGE_STYLE_TAG_TREE,
  AI_TAG_TREE
} from '@/data/global-opts'
import { LABEL_TYPES, LEVEL_TYPES, SOURCE_TYPES } from '@/views/material/tags/const'
const PAGE_REQUIRED_OPTS = initPageData([
  PROJECT_GROUP,
  MEDIA_ACCOUNTS,
  GAME_GROUPS,
  GAMES,
  MEDIAS,
  SYS_USERS,
  SYS_TAGS,
  SYS_TAG_GROUPS,
  IMAGE_STYLE_TAG_TREE,
  AI_TAG_TREE
])

export default {
  name: 'materialRecordFilter',
  components: { DateRangePicker, ThrottleSelector },
  computed: {
    ...PAGE_REQUIRED_OPTS,
    SOURCE_TYPES() {
      return SOURCE_TYPES
    },
    labelList() {
      return {
        contentLabels: this.SYS_TAGS.filter((tag) => tag.labelType === LABEL_TYPES.CONTENT_LABEL), // 内容标签
        threeDLabels: this.SYS_TAGS.filter((tag) => tag.labelType === LABEL_TYPES.THREED_LABEL)
      }
    }
  },
  data() {
    return {
      keyword: '',
      imageId: '',
      searchType: 1, // 搜索类型
      imageStyles: [],

      source: '',
      tagGroups: [], // 标签组
      labelId: [], // 标签ID
      opId: '',
      plannerId: '',
      groupId: '',
      dataGroupId: '',
      gameId: '',
      dataGameId: '',
      mediaId: '',
      launchOpIdList: [],
      platform: '',
      mediaAccount: [],
      aiLabelIds: [],
      uploadtime: [], // 初始上传时间
      lauchTime: [], // 消耗起始时间
      datetime: [],
      videoLabelId: [],
      imageTypes: [
        {
          id: 1,
          name: '图片'
        },
        {
          id: 2,
          name: '视频'
        },
        {
          id: 8,
          name: '组图'
        },
        {
          id: 14,
          name: '试玩素材'
        }
      ]
    }
  },
  activated() {
    // 内容标签曲线等其他场景点击标签跳转过滤需要手动查询数据
    const { labelId, videoLabelId, typeLabelId, datetime = this.datetime, mediaId, tagGroups = [] } = this.$route.query
    if (labelId || videoLabelId || typeLabelId) {
      this.labelId = labelId ? [parseInt(labelId)] : []
      this.datetime = datetime
      this.mediaId = mediaId ? parseInt(mediaId) : null
      this.tagGroups = tagGroups.map((mp) => parseInt(mp))
      // 清空其余条件
      this.keyword = ''
      this.imageId = ''
      this.searchType = 1
      this.imageStyles = []

      this.source = ''
      this.opId = ''
      this.plannerId = ''
      this.groupId = ''
      this.platform = ''
      this.mediaAccount = []
      this.aiLabelIds = []
      this.gameId = ''
      this.dataGameId = ''
      this.launchOpIdList = []
      this.dataGroupId = []
      this.videoLabelId = videoLabelId ? [Number(videoLabelId)] : []
      this.sendEvent()
    }
  },
  created() {
    const { labelId } = this.$route.query
    // const lastYear = moment().subtract(1, 'years').format('YYYY-MM-DD')
    const now = moment().format('YYYY-MM-DD')
    const yesterday = moment().subtract(1, 'days').format('YYYY-MM-DD')
    this.datetime = [yesterday, yesterday]
    // this.uploadtime = [lastYear, now]
    // 特殊场景（路由带labelId参数）会在 activated 中处理其他就在 created 中处理
    if (!labelId) {
      this.proLoadData()
    }
  },
  methods: {
    disabledDate(date) {
      return date && date.valueOf() > Date.now() - 1000 * 60 * 60 * 24
    },
    /**
     * @description: 添加导出任务时转化查询条件为可读的字符串
     * @param {*} extraParams
     * @param {*} pageType
     * @return {*}
     */
    getTransferedTaskQueryConditions(extraParams, pageType) {
      return transferTaskQueryConditions.call(this, { ...this.buildParams(this.keyword), ...extraParams }, pageType)
    },
    buildParams(keyword) {
      const imageStyleIds = this.imageStyles.length ? this.imageStyles.map((i) => i.slice(-1)).flat() : []

      const labelIds = [this.labelId, this.videoLabelId, imageStyleIds].filter((i) => Array.isArray(i)).flat()
      const params = {
        designerId: this.opId || '',
        plannerId: this.plannerId || '',
        gameId: this.gameId || '',
        dataGameId: this.dataGameId || '',
        dataGroupId: this.dataGroupId || '',
        gameGroupId: this.groupId || '',
        mediaId: this.mediaId || '',
        imgType: this.imageId,
        labelGroupIdStr: this.tagGroups?.length ? this.tagGroups.join(',') : '',
        labelIdsStr: labelIds.join(','),
        source: this.source || '',
        launchOpIdsStr: this.launchOpIdList?.length ? this.launchOpIdList.join(',') : ''
      }

      const [beginTime, endTime] = this.datetime || []
      params.beginTime = beginTime
      params.endTime = endTime

      const [uploadBeginTime, uploadEndTime] = this.uploadtime || []
      if (uploadBeginTime && uploadEndTime) {
        params.uploadBeginTime = uploadBeginTime
        params.uploadEndTime = uploadEndTime
      }

      const [lauchTimeBegin, lauchTimeEnd] = this.lauchTime || []
      if (lauchTimeBegin && lauchTimeEnd) {
        params.lauchTimeBegin = lauchTimeBegin
        params.lauchTimeEnd = lauchTimeEnd
      }

      const key = [undefined, 'imageName', 'planName'][this.searchType]
      if (key) params[key] = trim(keyword)

      return params
    },

    sendEvent() {
      const params = this.buildParams(this.keyword)
      this.$emit('on-change', params)
    },
    /**
     * @description: 限制选取范围在90天内
     * @param {*} dates
     */
    handleDatetime(dates) {
      const [start, end] = dates

      // 报表素材分析的统计时间处理，需要限制在365天内
      // 报表新素材统计，需要限制在90天内
      const inAnalysisPage = this.$route.path.includes('material-analysis')
      const days = inAnalysisPage ? 365 : 90
      const limitDate = moment(end).subtract(days, 'days')
      if (limitDate.isAfter(start)) {
        this.$Message.warning(`日期范围不能超过${days}天！`)
        const newDate = limitDate.format('YYYY-MM-DD')
        this.datetime = [newDate, end]
        return false
      }

      this.datetime = dates
      this.sendEvent()
    },

    proLoadData() {
      this.sendEvent()
    }
  }
}
</script>
